/** Красный счётчик непрочитанных (styles/badges.css, .messengerUnreadBadge): больше 99 — «99+», ноль — ничего. */
export function MessengerUnreadBadge({ count, className }: { count: number; className?: string }) {
  if (count <= 0) return null;
  return <span className={className ? `messengerUnreadBadge ${className}` : 'messengerUnreadBadge'}>{count > 99 ? '99+' : String(count)}</span>;
}
